export const present: <T>(x: T | undefined | null) => x is NonNullable<T> = x => x !== null && x !== undefined;
